import { Skeleton } from '../styled'

const ContentLoadingState = () => {
  return (
    <Skeleton
      variant="rectangular"
      width="100%"
      height="100vh"
      animation="wave"
      sx={{ gridColumn: 'span 2', borderRadius: '12px' }}
    />
  )
}

export default ContentLoadingState
